import { AutoCheckRefresh } from 'pages/AutoCheck/AutoCheckRefresh'
import { FaInfoCircle } from 'react-icons/fa'
import { Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { ProcessedActiveFilters } from './ProcessedActiveFilters'
import { useAppSelector } from 'appState/store'

interface IAutoCheckHeaderProps {
  isrunAutocheckUser: boolean
  currentTab: string
}

export const AutoCheckPageHeader = ({ isrunAutocheckUser, currentTab }: IAutoCheckHeaderProps) => {
  const { processedGridApi } = useAppSelector((state) => state.batch)
  const isProcessedTab = currentTab === 'batch-processed'

  return (
    <Div data-testid="claims-page-header">
      <h1>Batch Processing </h1>
      <div>
        <Tooltip
          className="text-with-tooltip"
          tooltipText={
            <span className="text">
              Batch Processing allows you to upload a claim file to initiate AutoCheck or import the claims for use with
              Console Calling. After your file finishes processing, you can download the results in a CSV file.
            </span>
          }
          position={PositionEnum.bottom}
          positionContent={100}
          positionTooltipArrow={10}
          tooltipStyles={{
            'max-width': '22.75rem',
            width: '22.75rem',
            transform: 'translateY(63%) translateX(-12%)',
            // transform: 'translateX(-30%)',
            zIndex: 101,
          }}
          hideTimeout={0}
        >
          <FaInfoCircle />
        </Tooltip>
      </div>
      <div className="action_holder">
        {isrunAutocheckUser && (
          <div className="refresh_holder">
            <AutoCheckRefresh />
          </div>
        )}
        {isProcessedTab && processedGridApi && (
          <div className="filter_holder">
            <ProcessedActiveFilters gridApi={processedGridApi} />
          </div>
        )}
      </div>
    </Div>
  )
}

const Div = styled.div`
  height: ${({ theme }) => theme.constants.pageTitleHeight};
  display: inline-flex;
  width: 100%;
  align-items: center;
  padding: 0rem ${({ theme }) => theme.spacing.l};
  background: ${({ theme }) => theme.colors.neutral.lighter};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  margin-bottom: ${({ theme }) => theme.spacing.l};
  .action_holder {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .filter_holder {
    margin-left: auto;
    white-space: nowrap;
  }

  .refresh_holder {
    margin-left: ${({ theme }) => theme.spacing.s};
    white-space: nowrap;
  }
  h1 {
    ${({ theme }) => theme.typography.h4.bold};
    color: ${({ theme }) => theme.colors.primary.neutral};
    padding-block: 0.75rem;
    white-space: nowrap;
  }

  div {
    margin-left: 0.25rem;
    float: left;
    svg {
      color: ${({ theme }) => theme.colors.grey.light};
    }
    .text {
      margin-bottom: 0.1rem;
      /* ${({ theme }) => theme.typography.s.normal}; */
    }
  }
`
